import EDIFakeData from '../resources/EDIFakeData.webp'
import OTCScan from '../resources/OTCScan.gif'
import Tracebook from '../resources/Tracebook.webp'
import Scale2Print from '../resources/Scale2Print.webp'
import Sharc from '../resources/SHARC.webp'
import MachineMonitoring from '../resources/MachineMonitor.webp'
import RoboTender from '../resources/RoboTender.webp'
import ReactPlayer from 'react-player'
import RoboTenderVideo from '../resources/RoboTender-Demo.webm'
import ReactModal from 'react-modal'
import { useState } from 'react'

const projects = [
  {
    name: "SHARC",
    description: `This innovative IoT adapter makes it easy to connect a wide range of sensors and devices to your network, streamlining data collection and communication. Installation is fast and hassle-free—you're up and running in just five minutes! To make things even easier, we've developed dedicated software for SHARC devices, which I co-invented. Available as both a web client and a mobile app (downloadable from the app store), the software is designed to give you effortless control. It connects to devices using Bluetooth Low Energy (BLE) and MQTT, letting you view live sensor data, check current configurations, and adjust settings—all with just a few taps.`,
    image: Sharc,
    link: "https://www.mriiot.com/sharc",
    imageDescription: "Screenshot of SHARC application.",
    tech: ["MQTT", "BLE", "React-Native", "React", "Websockets", "Javascript", "Micropython", "ESP-IDF"]
  },
  {
    name: "Tracebook (In Development)",
    description: `This intelligent tracking platform makes it effortless to organize complex job hierarchies and equipment at enterprise scale—teams are up and running in minutes! The breakthrough feature is our conversational AI assistant that understands your operational data and provides instant answers through natural language. Built as a modern web application with mobile support, it leverages advanced visualization and real-time processing, letting you navigate unlimited project relationships, search all documentation, and get intelligent insights with just a few clicks.`,
    image: Tracebook,
    link: "https://tracebook.co/",
    imageDescription: "Screenshot of Tracebook application.",
    tech: ["React", "MongoDB", "AI", "Javascript", "Python", "RAG", "JWT", "Docker"]
  },
  {
    name: "OTCScan",
    description: `Real-time OTC market monitoring that outpaces major platforms like ThinkorSwim. This tracking platform delivers instant updates on pricing, share structure, trades, and unusual volume across all OTC markets. The platform excels at speed - consistently beating established trading platforms in data delivery while providing comprehensive market intelligence at a glance. Multiple users can collaborate with custom flags and personalized stock lists, making it easy to monitor exactly what matters to your trading strategy.`,
    image: OTCScan,
    // link: "https://tracebook.co/",
    imageDescription: "Screenshot of OTCScan application.",
    tech: ["React", "Python", "Node", "Postgres", "Websockets", "API", "Web Scraping", "Rotating Proxies"]
  },
  {
    name: "Scale2Print",
    description: `This comprehensive automation platform makes it incredibly simple to connect weighing scales directly to label printers, eliminating manual data entry and streamlining industrial workflows. Setup is remarkably fast—you can have multiple scales and printers integrated and printing automatically within minutes! Built as a full-stack Node.js application with a React dashboard, it handles real-time serial communication, network printer protocols, and intelligent data parsing, letting you monitor multiple scales simultaneously, trigger printing remotely, and maintain complete activity logs—all through an intuitive web interface that updates in real-time.`,
    image: Scale2Print,
    // link: "https://tracebook.co/",
    imageDescription: "Screenshot of Scale2Print application.",
    tech: ["React", "Javascript", "Docker", "Serial", "MQTT", "TCP/IP"]
  },

  {
    name: "RoboTender",
    description: `To deepen my understanding of embedded programming, I built an IoT beverage dispenser from scratch as a personal project. I developed ESP-32 firmware to manage MQTT messaging, enabling seamless communication with a custom mobile app. The system controls LED lights, monitors an ultrasonic sensor, and operates peristaltic pumps to dispense drinks precisely. I wired and configured all hardware components, ensuring reliable performance. I also created a mobile app that lets users select drink types, customize sizes, and adjust pump settings, syncing with the hardware in real time via MQTT. In the future I would like to design an enclosure for it so the wires are not everywhere.`,
    image: RoboTender,
    link: "",
    imageDescription: "Picture of RoboTender",
    tech: ["MQTT", "React-Native", "Javascript", "Arduino", "ESP-IDF", "ESP-32"]
  },
  {
    name: "Automated EDI Portal",
    description: `This was made to allow seamless order processing, reduce the workload on the customer service team, and ensure full compliance with the client's requirements. Additionally, the client wanted the EDI system to handle both inbound and outbound data, such as invoices and shipment notices, without any manual intervention.`,
    image: EDIFakeData,
    link: "https://mriiot.com/case-studies/order-processing",
    imageDescription: "Screenshot of EDI Portal.",
    tech: ["Postgres", "React", "Node-RED", "Postgrest", "Javascript", "Docker"]
  },
  {
    name: "Machine Monitoring Dashboard",
    description: `This system was built to give you a clear, real-time view of how a plant with 10+ machines is performing. Data comes straight from the machines with almost no delay, so you always know what's happening as it happens. It doesn't stop at real-time updates—everything is stored, so you can easily look back at data from days, weeks, or even months ago. Whether you're solving a problem, spotting trends, or just checking in, this system makes it simple to stay on top of your operations.`,
    image: MachineMonitoring,
    link: "https://mriiot.com/case-studies/digital-transformation",
    imageDescription: "GIF of machine monitoring dashboard.",
    tech: ["Splunk", "Node-RED", "MTConnect", "Javascript", "OOP", "Docker"]
  }
]

const Projects = () => {
  const [openModal, setOpenModal] = useState(false);

  return (
    <div id="projects">
      <h1 className="projects">
        <section>02.</section>Projects
      </h1>
      <div className="projects-intro">
        <p>
          I have worked on many different projects whether it be solo or in large teams for various clients.
          I have also worked on quite a few personal projects when I have some spare time. Below are just a
          couple of the projects I have worked on, I would love for you to check them out!
        </p>
      </div>
      <div className="projects-container">
        {projects.map((project, index) => {
          const isRoboTender = project.name === 'RoboTender';

          return (
            <div key={index} className={project.name.toLowerCase().replace(/\s+/g, '-')}>
              <div className="project-content">
                <div className="project-text">
                  <h3>
                    {isRoboTender ? (
                      <span
                        onClick={() => setOpenModal(true)}
                        style={{ cursor: 'pointer' }}
                        className="marina-site-title"
                      >
                        {project.name}
                      </span>
                    ) : (
                      <a
                        href={project.link}
                        target="_blank"
                        rel="noreferrer"
                        className="marina-site-title"
                      >
                        {project.name}
                      </a>
                    )}
                  </h3>
                  <p className="projectDesc">{project.description}</p>
                  <div className="tech-stack">
                    {project.tech.map((tech, techIndex) => (
                      <span key={techIndex} className="tech-tag">{tech}</span>
                    ))}
                  </div>
                </div>
                <div className="project-image">
                  {isRoboTender ? (
                    <div onClick={() => setOpenModal(true)} style={{ cursor: 'pointer' }}>
                      <img src={project.image} className="marinaSS" alt={project.imageDescription} />
                    </div>
                  ) : (
                    <a href={project.link} target="_blank" rel="noreferrer">
                      <img src={project.image} className="marinaSS" alt={project.imageDescription} />
                    </a>
                  )}
                </div>
              </div>
            </div>
          );
        })}
      </div>

      {/* Modal for RoboTender video */}
      <ReactModal
        isOpen={openModal}
        onRequestClose={() => setOpenModal(false)}
        style={{
          overlay: {
            backgroundColor: "rgba(0, 0, 0, 0.9)",
            zIndex: 1000,
          },
          content: {
            top: '50%',
            left: '50%',
            right: 'auto',
            bottom: 'auto',
            marginRight: '-50%',
            transform: 'translate(-50%, -50%)',
            padding: '0',
            border: 'none',
            background: 'transparent',
            borderRadius: '12px',
            overflow: 'hidden',
          },
        }}
      >
        <div style={{ position: "relative", width: '80vw', maxWidth: '800px' }}>
          <ReactPlayer
            url={RoboTenderVideo}
            playing
            controls
            width="100%"
            height="450px"
            style={{
              borderRadius: '12px',
              overflow: 'hidden',
            }}
          />
          <button
            className='exit-button-modal'
            onClick={() => setOpenModal(false)}
            style={{
              position: "absolute",
              top: "15px",
              right: "15px",
              backgroundColor: "rgba(0, 0, 0, 0.7)",
              color: "white",
              border: "none",
              borderRadius: "50%",
              width: "40px",
              height: "40px",
              fontSize: "20px",
              cursor: "pointer",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              zIndex: 1001,
            }}
          >
            ×
          </button>
        </div>
      </ReactModal>
    </div>
  )
}

export default Projects;
